<template>
    <div>
        <HeaderBreadcrumbs :items="[
            { label: 'Publisher Group', to: '/publisher-group' },
            { label: 'Edit' }
        ]" title="Edit Publisher Group" />
          <div class="flex-col justify-start items-center bg-white w-full shadow-sm rounded-lg">
   <FormDataPublisherGroup 
        :form="form" 
        :vendorsAlready="vendorsAlready"
        :invalidName.sync="invalidName"
        :invalidNameEmpty.sync="invalidNameEmpty"
        :invalidVendorsEmpty.sync="invalidVendorsEmpty" 
        />
          <div class="px-4 pb-4">
            <button class="bg-blue-700 text-white rounded-lg p-1.5 px-2" @click="editPublisherGroup()">Save</button>
             <button class="bg-white text-gray-700 border ml-3 rounded-lg p-1.5 px-2" @click="handleCancel()">Cancel</button>
        </div>
          </div>
     
       
    </div>

</template>

<script>
import { mapActions, mapState } from 'vuex';
// import constant from '../../store/constant';
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';
import { EventBus } from '../../../event-bus'
import FormDataPublisherGroup from '../form-data-publisher-group.vue';


export default {
    name: 'EditPublisherGroup',
    components: {
        HeaderBreadcrumbs,
        FormDataPublisherGroup
    },
    data() {
        return {
            form: {
                name: '',
                vendors: null,
            },
            vendorsAlready: [],
            invalidName: false,
            invalidNameEmpty: false,
            invalidVendorsEmpty: false,
        };

    },
    computed: {
        ...mapState({
            item: (state) => state.vendors.item,
            successMessage: (state) => state.vendors.successMessage,
            errorMessage: (state) => state.vendors.errorMessage,
        }),
    },
    watch: {
        item: function() {
            this.getOPublisherGroup()
    },
        successMessage: function () {
            if (!this.successMessage) return;
            EventBus.$emit('show-toast', {
                message: 'Publisher group has been updated.',
                type: 'success',
            });
            this.$router.push('/publisher-group');
        },
        errorMessage: {
            handler(errorObj) {
                if (!errorObj) return;
                const error = errorObj.message.data;
                if (error === 'Name already exists in another vendor group.') {
                    this.invalidName = true;
                }
            },
            deep: true
        }
    },
  created: function() {
    const vendorID = this.$route.params.id;
    const payload = {
        id:vendorID
    }
    this.fetchPublisherGroupById(payload);
  },
  mounted() {
  
  },
    methods: {
        ...mapActions('vendors', ['fetchPublisherGroupById','updatePublisherGroup']),

        async editPublisherGroup() {
            this.invalidNameEmpty = false;
            this.invalidVendorsEmpty = false;

            const errors = {
                name: !this.form.name?.trim(),
                vendors: !this.form.vendors?.length
            };

            this.invalidNameEmpty = errors.name;
            this.invalidVendorsEmpty = errors.vendors;

           if (errors.name || errors.vendors) return;

               try {
                const data = this.form;
                const payload = {
                    id:this.$route.params.id,
                    name: data.name,
                    vendors: data.vendors.map(item => item.id),
                };
              await  this.updatePublisherGroup(payload);
            }
            catch (err) {
             this.vendorsAlready = err.duplicates?.map?.(v => v.id) || [];
            }
        },
        handleCancel() {
            this.$router.push('/publisher-group');
        },
        getOPublisherGroup() {
               const data = this.item;
               this.form.name = data.name
               this.form.vendors = data.vendors
              
        }
    },
};
</script>